module.exports = __webpack_public_path__ + "img/auth5.672a3035.png";